// Deep-cleanup reload: unregister every active service worker and wipe all
// Cache Storage entries before triggering a real navigation. Mirrors the
// swRecovery block in public/index.html — that one runs at boot when bundle
// loads fail; this one runs at runtime when we detect a version mismatch.
//
// Why not plain window.location.reload(): the SW's NetworkFirst route can
// still serve a stale index.html from the 'navigation' cache if the network
// is slow or flaky during the reload. Clearing caches + unregistering the
// SW first guarantees the next request goes to origin and the user actually
// gets the new bundle. A reload that doesn't reload is a much worse failure
// than a slightly slower one.
//
// try/finally ensures the reload still fires even if unregister or
// caches.delete throws (private mode, permissions, etc.).
const hardReload = async () => {
  try {
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
    }
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    }
  } finally {
    window.location.reload();
  }
};

export default hardReload;
